import { NavigateFunction } from 'react-router'

import type { FileType, Metadata, TrackingRecordType } from './types'
import {
  ADD_ERROR,
  CLEAR_ALL_ERRORS,
  CLEAR_ERROR,
  CREATE_IMAGE_PREVIEWS,
  DISPLAY_IN_MODAL,
  FIND_AUTHUNAUTH,
  ON_TRACKING_ERROR,
  SAVE_IMAGE_PREVIEW,
  SHOW_ALL_CATEGORIES,
  TOGGLE_CATEGORY_PREVIEW,
  UPLOAD_CLEAR,
  UPLOAD_CLEAR_MOST,
  UPLOAD_DELETE,
  UPLOAD_FAILURE,
  UPLOAD_FINISHED,
  UPLOAD_PROGRESS,
  UPLOAD_REQUEST,
  UPLOAD_REQUESTING,
  UPLOAD_SELECT_CATEGORY,
  UPLOAD_SELECT_HANDLER,
  UPLOAD_SUCCESS
} from './upload-constants'

const uploadRequesting = () => ({ type: UPLOAD_REQUESTING })
const uploadSelectCategory = (category: string) =>
  ({ type: UPLOAD_SELECT_CATEGORY, category })
const uploadSelectHandler = (handler: string) => ({ type: UPLOAD_SELECT_HANDLER, handler })
const uploadDelete = (id: string) => ({ type: UPLOAD_DELETE, id })
const uploadClear = () => ({ type: UPLOAD_CLEAR })
const uploadClearMost = () => ({ type: UPLOAD_CLEAR_MOST })
const uploadRequest = (
  // navigate is non-serializable and it is an antipattern in redux
  // to include it as part of the action. However, we need to navigate
  // in our saga, and this function is not set in state nor mutated, so
  // it should be okay to include it here.
  navigate: NavigateFunction,
  files: FileType[],
  meta: Metadata,
  trackingInfo?: TrackingRecordType,
) =>
  ({ type: UPLOAD_REQUEST, navigate, files, meta, trackingInfo })
const uploadProgress = (
  filename: string,
  progress: number,
  timeLeft: number,
  trackingId: string,
  batchId?: string
) => ({ type: UPLOAD_PROGRESS, filename, progress, timeLeft, trackingId, batchId })
const uploadSuccess = () => ({ type: UPLOAD_SUCCESS })
const uploadFinished = () => ({ type: UPLOAD_FINISHED })
const uploadFailure = (filename: string, error: unknown, trackingId: string, batchId?: string) =>
  ({ type: UPLOAD_FAILURE, filename, error, trackingId, batchId })
const createImagePreview = (files: FileType[]) => ({ type: CREATE_IMAGE_PREVIEWS, files })
const saveImagePreview = (filename: string, src: string, mimeType: string) =>
  ({ type: SAVE_IMAGE_PREVIEW, filename, src, mimeType })
const displayInModal = (filename: string) => ({ type: DISPLAY_IN_MODAL, filename })
const toggleCategory = (category: string) => ({ type: TOGGLE_CATEGORY_PREVIEW, category })
const showAllCategories = () => ({ type: SHOW_ALL_CATEGORIES })
const findAuthUnauth = (sourceSystem: string) => ({ type: FIND_AUTHUNAUTH, sourceSystem })
const onTrackingError = (trackingError: boolean) => ({ type: ON_TRACKING_ERROR, trackingError })

/** error managment  */
const addError = (name: string, error: unknown) => ({ type: ADD_ERROR, name, error })
const clearError = (name: string) => ({ type: CLEAR_ERROR, name })
const clearAllErrors = () => ({ type: CLEAR_ALL_ERRORS })

export {
  addError,
  clearAllErrors,
  clearError,
  createImagePreview,
  displayInModal,
  findAuthUnauth,
  onTrackingError,
  saveImagePreview,
  showAllCategories,
  toggleCategory,
  uploadClear,
  uploadClearMost,
  uploadDelete,
  uploadFailure,
  uploadFinished,
  uploadProgress,
  uploadRequest,
  uploadRequesting,
  uploadSelectCategory,
  uploadSelectHandler,
  uploadSuccess
}
